import { PermissionT } from "../types";

export const enterpriseSupport = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "enterprise_support");
  return !!p;
};
export default enterpriseSupport;
